const STORAGE_KEY = 'dechess-recovery-backed-up-v1';

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
}

export function hasRecoveryBackupAcknowledged(playerId) {
  return Boolean(readStore()[playerId]);
}

export function markRecoveryBackupAcknowledged(playerId) {
  const store = readStore();
  store[playerId] = true;
  writeStore(store);
}

export function clearRecoveryBackupAcknowledged(playerId) {
  const store = readStore();
  delete store[playerId];
  writeStore(store);
}
